// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"8c490acc","189":"8c490acc","472":"8c490acc","474":"8c490acc","479":"8c490acc"}[chunkId] + ".chunk.css";
};